export default "__VITE_ASSET__f$3mO0r2__"